export const header = {
  nav_home: "Home",
  nav_about: "Über uns",
  nav_services: "Services",
  nav_partnership: "Partnerschaft",
  nav_contact: "Kontakt",
  logo_tagline: "linking people & business",
};

export const brand = {
  tagline_linking: "Linking People & Business",
  tagline_excellence: "Driving to excellence with excellent drivers …",
};

export const hero = {
  slide1_title: "Neue Märkte, neues Geschäft ... kein Risiko!",
  slide2_title: "Mit uns mitten ins Herz Europas!",
  slide3_title: "Deutschland (DACH) – Ihr Erfolg mit einem Partner vor Ort!",
  slide4_title: "Gemeinsam stark!",
  slide4_subtitle: "Business Development\nConsulting\nInterim Management\nTraining & Coaching",
  slide5_title: "Jetzt durchstarten!",
  prev_slide: "Vorherige Folie",
  next_slide: "Nächste Folie",
  slide_label: "Folie {{number}}",
};

export const intro = {
  title: "NetBasis International - linking people & business",
  heading:
    "Ihr operativer Partner für Ihren erfolgreichen Markteintritt in der DACH-Region. Wir unterstützen und steuern Ihre Marktaktivitäten vor Ort – maßgeschneidert durch die Übernahme der gesamten lokalen Tätigkeit oder flexibel für einzelne Aufgabenbereiche.",
  paragraph1:
    "Der erfolgreiche Aufbau, die Steigerung und die Expansion von Geschäften in neuen Märkten müssen für ausländische Unternehmen vor allem eines sein: vielversprechend, schnell, effizient, kostengünstig und sicher. Langwierige Marktstudien, komplizierte Strategieentwicklungen mit unklaren Entscheidungsprozessen oder der fehlende direkte Zugang zum Zielmarkt sind hierbei der falsche Ansatz. Oft möchten Hersteller einen neuen Markt zudem ohne große Vorab-Investitionen betreten.",
  paragraph2:
    "Genau an diesem Punkt ist NetBasis International der richtige Partner an Ihrer Seite. Seit fast 20 Jahren begleiten und unterstützen wir ausländische Unternehmen aus der Telekommunikations- und IT-Branche erfolgreich in attraktiven, aber anspruchsvollen Märkten – mit klarem Fokus auf den deutschsprachigen Wirtschaftsraum (DACH-Region).",
  strong_name: "NetBasis International",
};

export const services = {
  service1_title: "Business Development",
  service1_description:
    "Sie möchten Ihr in Ihren Heimatmärkten erfolgreiches Geschäft auf neue Handelsplätze ausweiten oder suchen Unterstützung bei bereits begonnenen Vorhaben in neuen Märkten?",
  service2_title: "Consulting",
  service2_description:
    "Sie wünschen Beratung in verschiedenen Themengebieten zum Eintritt in neue Märkte, um den Erfolg Ihres Geschäftsvorhabens zu gewährleisten, beziehungsweise nicht zu gefährden?",
  service3_title: "Interim Management",
  service3_description:
    "Sie benötigen sehr dringend und kurzfristig zeitlich begrenzte, kompetente Hilfe bei der Erledigung bestimmter Aufgaben und/oder zur Überbrückung eines personellen Engpasses?",
  service4_title: "Training & Coaching",
  service4_description:
    "Sie möchten sich optimal auf die Gegebenheiten neuer Märkte einstellen, auf individuelle Konstellationen sowie regulatorische Anforderungen und kulturelle Unterschiede?",
  read_more: "Mehr erfahren",
};

export const about = {
  title: "NetBasis International - drive to excellence with excellent drivers !",
  paragraph1:
    "Als anerkannte Experten mit Sitz in Deutschland – dem bedeutendsten europäischen Markt – helfen wir von NetBasis International Ihnen, Eintrittsbarrieren abzubauen, strategische Optionen zu prüfen, realistische Vermarktungskonzepte zu entwickeln, geeignete Partner zu finden und potenzielle Kunden direkt anzusprechen. Zuverlässig und ergebnisorientiert bieten wir Ihnen eine breite Palette an Services: von der Markteintritts- und Entwicklungsplanung über Vertrieb, Marketing und Öffentlichkeitsarbeit bis hin zu technischem Support und Personalbeschaffung.",
  paragraph2:
    "Durch die Zusammenarbeit mit uns profitieren Sie von einer zentralen Anlaufstelle für Ihr gesamtes Projekt. Sie erhalten sofortigen Zugriff auf das notwendige Know-how und die operative Expertise, die für Ihren Markterfolg unabdingbar sind. Mit unserem pragmatischen Ansatz erarbeiten wir gemeinsam die spezifischen Bedingungen und Anforderungen Ihrer Zielländer.",
  paragraph3:
    "Dabei haben Sie die Wahl, wie Sie uns einsetzen: Wir können das gesamte Projekt übernehmen und erfüllen an Ihrer Stelle für eine festgelegte oder unbestimmte Zeit die tatsächliche Arbeit vor Ort. Alternativ unterstützen wir Sie gezielt bei einzelnen Aufgaben, begleiten Sie rein beratend als Consultants auf Ihrem eigenen Weg oder kooperieren mit Ihnen im Bereich Training und Coaching.",
  paragraph4:
    "Für welche Services Sie sich auch entscheiden: {{strong}} stimmt alle relevanten Mittel und Maßnahmen perfekt aufeinander ab, um Ihr Business effizient voranzubringen.",
  strong_name: "NetBasis International",
};

export const experience = {
  title: "Erfahrung & Erfolgsbilanz",
  subtitle: "Über 12 Jahre erfolgreiche Markterschließung und Geschäftsentwicklung in der DACH-Region",
  stat1_value: "12+",
  stat1_label: "Jahre im Geschäft",
  stat2_value: "50+",
  stat2_label: "Abgeschlossene Projekte",
  stat3_value: "30+",
  stat3_label: "Internationale Kunden",
  stat4_value: "4",
  stat4_label: "Kerndienstleistungen",
  intro:
    "Seit unserer Gründung ist NetBasis International die vertrauenswürdige Brücke für ausländische ITK-Hersteller beim Eintritt in die deutschsprachigen Märkte. Unsere Erfolgsbilanz spricht für sich — wir haben wiederholt bewiesen, dass der Markteintritt mit dem richtigen lokalen Partner planbar, effizient und erfolgreich wird.",
  timeline1_year: "2012",
  timeline1_title: "Gründung & erste Projekte",
  timeline1_desc: "Gründung von NetBasis International mit der Vision, innovative ITK-Unternehmen aus aller Welt mit dem DACH-Markt zu verbinden. Erste erfolgreiche Markteintrittsprojekte für asiatische und nordamerikanische Hersteller.",
  timeline2_year: "2015",
  timeline2_title: "Erweiterung des Service-Portfolios",
  timeline2_desc: "Ausbau unseres Angebots um umfassende Beratungsdienstleistungen, Interim Management und Trainingsprogramme. Aufbau eines Netzwerks vertrauenswürdiger Partner in Deutschland, Österreich und der Schweiz.",
  timeline3_year: "2018",
  timeline3_title: "Internationale Anerkennung",
  timeline3_desc: "Anerkennung als führender Go-to-Market-Partner für die DACH-Region. Unterstützung von Kunden aus über 15 Ländern auf vier Kontinenten beim Aufbau und Wachstum ihrer europäischen Präsenz.",
  timeline4_year: "2022",
  timeline4_title: "Strategisches Wachstum & neue Märkte",
  timeline4_desc: "Vertiefung der Expertise in den Bereichen Telekommunikation, IT-Infrastruktur und digitale Lösungen. Erweiterung der Beratungsdienste um regulatorische Compliance, kulturelle Anpassung und langfristige Marktpositionierungsstrategien.",
  timeline5_year: "2026",
  timeline5_title: "Ihr Partner für Morgen",
  timeline5_desc: "Kontinuierliche Weiterentwicklung mit der sich verändernden Marktlandschaft. Heute bieten wir ein vollständiges Dienstleistungspaket, das ausländischen Unternehmen den Eintritt in die DACH-Region mit Vertrauen ermöglicht — kein Risiko, nur Ergebnisse.",
};

export const contact = {
  title: "Nehmen Sie jetzt direkt Kontakt mit uns auf.",
  cta_button: "Kontaktformular",
};

export const footer = {
  privacy: "Datenschutz",
  contact: "Kontakt",
  imprint: "Impressum",
  copyright: "Copyright © {{year}} NetBasis International. Alle Rechte vorbehalten.",
};

export const pages = {
  about_title: "Über uns",
  about_subtitle: "Über 12 Jahre Erfahrung in der Markterschließung – lernen Sie das Team und die Erfolge hinter NetBasis International kennen",
  about_cta: "Bereit für Ihren Markteintritt?",
  about_cta_button: "Jetzt Kontakt aufnehmen",
  about_footer_claim: "NetBasis International - drive to excellence with excellent drivers !",
  experience_title: "Erfahrung",
  contact_title: "Kontakt",
  privacy_title: "Datenschutz",
  imprint_title: "Impressum",
  placeholder: "Diese Seite wird in Kürze mit Inhalten gefüllt. Wir arbeiten daran!",
};

export const aboutHero = {
  title_line1: "Wir machen, dass ",
  title_line2: "sich was bewegt ...",
  subtitle: "... für SIE!",
  heroAlt: "Finger berührt einen leuchtenden digitalen Punkt für ITK-Vernetzung im DACH-Markt.",
};

export const aboutPage = {
  introTitle: "NetBasis International - linking people & business",
  p1: "NetBasis International wurde Anfang des Jahres 2008 in Düsseldorf gegründet. Seitdem bieten wir ausländischen Herstellern aus der Telekommunikations- und/oder IT-Branche, die ihre Geschäftstätigkeit in die DACH-Märkte ausweiten oder bereits existierende Aktivitäten intensivieren möchten, unter dem Motto „linking people & business“ jegliche Form der Beratungs- und Handelsunterstützung sowie Hilfe bei der marktspezifischen Produktentwicklung bzw. -anpassung.",
  p2: "Gemeinsam mit unseren Herstellerpartnern beantworten wir alle Fragen und arbeiten für sie rund um das eine Anliegen: Erfolg und beste Geschäftsresultate in neuen Märkten!",
  p3: "Zur Erreichung dieses Ziels erhalten ausländische Unternehmen mit uns unmittelbaren Zugriff auf branchenspezifisches Wissen, langjährige Erfahrung und weitreichende Kontakte, sie vermeiden durch uns kulturelle und/oder sprachliche Barrieren bei sofortiger Präsenz, und sie bekommen von uns prompte Arbeit an Markt/Märkten, Produkt(en), Partnern und Kunden.",
  p4: "Zur Stärkung bestehender Beziehungen sowie zur Gewinnung neuer Kunden und somit zur nachhaltigeren Erschließung neuer Märkte führt ein partnerschaftlicher Umgang in allen Bereichen des Vertriebs und Marketings sowie die gemeinsame Arbeit an anspruchsvollen und den Markterfordernissen angepassten Produkten und Lösungen (Hard- und Software).",
  p5: "Sowohl unsere Unternehmensphilosophie als auch unsere ethische Ausrichtung bringen mit sich, dass sich NetBasis International strategisch auf eine begrenzte Anzahl von kompetenten Herstellerpartnern konzentriert, die innerhalb der Branche nicht in Konkurrenz stehen. Denn wir geben gemeinsamer Entwicklung und synergetischer Zusammenarbeit innerhalb der Gruppe den Vorzug gegenüber unproduktivem Wettbewerb.",
  p6: "All dies bietet Sicherheit für jeden neuen Partner und ist Teil des Pakets, das wir Ihnen anbieten, falls Sie sich entscheiden, mit uns zu arbeiten.",
  footerClaim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const aboutCards = {
  management_title: "Management",
  management_desc:
    "Christof Günther hat NetBasis International Anfang 2008 gegründet und ist Inhaber. Mit mehr als 30 Jahren internationaler Erfahrung in der ITK-Branche hilft er ausländischen Herstellern, mit ihren Produkten neue Märkte zu erschließen.",
  core_values_title: "Grundwerte",
  core_values_desc:
    "Respekt. Loyalität. Professionalität. Ausdauer. Vertrauen. Das sind die Grundwerte, denen sich NetBasis International verschrieben hat und die uns durch unsere tägliche Arbeit führen.",
  mission_vision_title: "Mission/Vision",
  mission_vision_desc:
    "Ja, es sind immer Ergebnisse, die am Ende zählen. Aber das Entscheidende auf dem Weg dahin sind immer Menschen! NetBasis International ermöglicht Ihnen, ganz leicht mit Ihrem Geschäft in neuen Märkten zu beginnen.",
  read_more: "Mehr erfahren",
};

export const aboutSubPages = {
  management: {
    title: "Management",
    heroLine1: "Mit Kompetenz zum Ziel!",
    heroLine2: "",
    heroAlt: "Hand wählt ein hervorgehobenes Personenprofil für kompetentes ITK-Management im DACH-Markt.",
    p1_founded: "hat ",
    p1_owner: "Anfang 2008 gegründet und ist Inhaber.",
    p1: "Christof Günther hat NetBasis International Anfang 2008 gegründet und ist Inhaber.",
    p2: "Mit mehr als 30 Jahren internationaler Erfahrung in der ITK-Branche hilft er ausländischen Herstellern, mit ihren Produkten neue Märkte zu erschließen. Dabei liegt sein fachlicher Fokus auf allen Bereichen des „Business Development“. Hier erarbeitet er für und mit seinen Geschäftspartnern ganzheitliche Markteinführungskonzepte und unterstützt sie bei der Umsetzung und Steuerung ihrer gesamten Projektvorhaben.",
    p3: "Ebenso bietet er interessierten Unternehmen sein Marktwissen und seine Branchenkenntnisse über Beratungsmandate oder durch Trainings und Coachings an.",
    p4: "Vorher war Herr Günther über viele Jahre in verantwortungsvollen Positionen (Niederlassungsleiter, Vertriebsleiter, Exportleiter, etc.) bei europa- und/oder weltweit operierenden mittelständischen Telekommunikations- und IT-Unternehmen tätig.",
  },
  core_values: {
    title: "Grundwerte",
    heroLine1: "Mit Werten",
    heroLine2: "zum Erfolg!",
    heroAlt: "Offene Hand trägt leuchtende digitale Linien als Symbol für Vertrauen und Grundwerte bei NetBasis.",
    p1: "Respekt. Loyalität. Professionalität. Ausdauer. Vertrauen.",
    p2: "Das sind die Grundwerte, denen sich NetBasis International verschrieben hat und die uns durch unsere tägliche Arbeit führen. Sie begleiten uns in unserem Engagement für unsere Geschäftspartner und leiten uns in der Art, wie wir unsere Aufgaben erledigen.",
    p3: "Es ist unser Anspruch an uns selbst, sowohl neuen Partnern zu beweisen, dass sie mit uns die richtige Wahl getroffen haben, als auch existierenden Partnern in neuen Projekten immer wieder neu zu zeigen, dass sie bei uns gut aufgehoben sind.",
    p4: "Ihr Erfolg ist uns Verpflichtung.",
  },
  mission_vision: {
    title: "Mission/Vision",
    heroLine1: "Mit Teamwork",
    heroLine2: "zum Erfolg!",
    heroAlt: "Teammitglieder legen ihre Hände übereinander für gemeinsamen Markteintritt in den DACH-Markt.",
    p1: "Ja, es sind immer Ergebnisse, die am Ende zählen. Aber das Entscheidende auf dem Weg dahin sind immer Menschen!",
    p2: "NetBasis International ermöglicht Ihnen, ganz leicht mit Ihrem Geschäft in neuen Märkten zu beginnen und sehr schnell (nicht nur erste) Ergebnisse zu erzielen. Mit einem/einer guten Produkt/Lösung befähigen wir Sie, Ihre Strategie unverzüglich und erfolgreich umzusetzen. Wir helfen Ihnen, agil und wettbewerbsfähig zu sein.",
    p3: "Allerdings, erfolgreiches Geschäft kann und wird nicht durch Produkte/Lösungen alleine zustande kommen. Produkte/Lösungen verkaufen sich nicht von selbst. Exzellente Produkte/Lösungen alleine werden keine Ergebnisse und Erfolg bringen.",
    p4: "Ergebnisse und Erfolg, vor allem auf lange Sicht, beginnen immer mit Menschen und brauchen immer Menschen. Es sind immer Menschen, die gemeinsam an individuellen Geschäftsstrategien und Zielen arbeiten und die die zu Anforderungen, Plänen und Zielen am besten passende Vorgehensweise entwickeln. Wir glauben an diesen an Menschen ausgerichteten Ansatz und sind überzeugt, dass genau er es ist, der den Unterschied im Geschäftsleben ausmacht.",
    p5: "Deshalb ist eine gute und intensive Zusammenarbeit unser zentraler Weg, Geschäft zu machen. Unsere Experten schließen sich mit Ihren Mitarbeitern zusammen, um ein starkes und enges Team zu bilden, ein Team von „Drivers“, das Ihr Markteintrittsprojekt ganz sicher zu einem Erfolg machen wird.",
  },
};

export const experiencePage = {
  title: "Erfahrungen",
  heroClaimLine1: "Erfahrung & Expertise",
  heroClaimLine2: "... die Basis für Ihren Erfolg!",
  benefits_title: "Was Sie hier bald erwarten können",
  benefit_0: "Überblick über erfolgreich abgeschlossene Projekte und Markteintritte",
  benefit_1: "Kundenstimmen und Partnerschaftserfahrungen",
  benefit_2: "Detaillierte Einblicke in Branchen- und Marktkenntnisse",
  benefit_3: "Chronologie und Meilensteine unserer Unternehmensgeschichte",
  claim: "NetBasis International - drive to excellence with excellent drivers !",
};

export const contactPage = {
  hero: {
    title: "Wir freuen uns auf",
    subtitle: "Ihre Nachricht!",
    heroAlt: "Zwei Hände präsentieren eine leere Visitenkarte für den Kontakt zu NetBasis in Düsseldorf.",
  },
  details: {
    title: "Kontaktdaten",
    company: "NetBasis International",
    address_line1: "Heinrichstraße 45",
    address_line2: "40239 Düsseldorf",
    address_country: "Deutschland",
    tel_label: "Telefon:",
    tel_number: "+49 (0) 211 / 544 193 80",
    email_label: "E-Mail:",
    email_address: "kontakt@net-basis.com",
  },
  form: {
    title: "Kontaktieren Sie uns gerne",
    name: "Vor- und Nachname",
    name_placeholder: "Ihr Name",
    company: "Firma",
    company_placeholder: "Ihre Firma",
    email: "E-Mail-Adresse",
    email_placeholder: "ihre@email.de",
    phone: "Telefonnummer",
    phone_placeholder: "+49 (0) ...",
    message: "Ihre Nachricht",
    message_placeholder: "Ihre Nachricht an uns...",
    dsgvo_text: "Ich stimme zu, dass meine Daten aus dem Kontaktformular zur Beantwortung meiner Anfrage erhoben und verarbeitet werden. Die Daten werden gelöscht, nachdem die Bearbeitung Ihrer Anfrage abgeschlossen ist. Detaillierte Informationen zum Umgang mit Nutzerdaten finden Sie in unserer Datenschutzerklärung.",
    submit: "senden",
    success_title: "Vielen Dank!",
    success_message: "Ihre Nachricht wurde erfolgreich gesendet. Wir melden uns schnellstmöglich bei Ihnen.",
    error_default: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
    spam_question: "Sicherheitsfrage: Was ist",
    spam_error: "Bitte beantworten Sie die Sicherheitsfrage.",
    spam_wrong: "Die Antwort ist leider falsch. Bitte versuchen Sie es erneut.",
  },
  map: {
    title: "Unser Standort",
    preview_title: "Google Maps ist deaktiviert",
    preview_text: "Wenn Sie Google Maps aktivieren, wird Ihre IP-Adresse an Server von Google in den USA übertragen. Details dazu finden Sie in unserer Datenschutzerklärung.",
    activate_button: "Inhalt aktivieren",
  },
};

export const cookie_banner = {
  text: "Diese Website verwendet ausschließlich technisch notwendige Cookies. Es werden keine Tracking- oder Analyse-Cookies eingesetzt. Ein Cookie speichert Ihre Entscheidung zur Google Maps-Nutzung, ein weiteres dient dem Cloudflare Bot-Schutz.",
  privacy_link: "Mehr dazu in der Datenschutzerklärung.",
  button: "Verstanden",
};

export const legalPage = {
  heroAlt: "Finger berührt vernetzte Paragrafenzeichen für Impressum und Datenschutz bei NetBasis.",
};

export const imprintPage = {
  title: "Impressum",
  left_title: "Impressum",
  provider_title: "Angaben gemäß § 5 DDG",
  provider_text: "Christof Günther\nNetBasis International\nHeinrichstraße 45\n40239 Düsseldorf",
  contact_title: "Kontakt",
  phone_label: "Telefon:",
  phone: "+49 (0) 211 / 544 193 80",
  email_label: "E-Mail:",
  email: "kontakt@net-basis.com",
  web_label: "Internet:",
  web: "net-basis.net",
  vat_title: "Umsatzsteuer-ID",
  vat_text: "Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:\nDE 258 486 954",
  insurance_title: "Berufshaftpflichtversicherung",
  insurance_text: "Name und Sitz der Gesellschaft:\nHiscox AG in Vollmacht für Hiscox Insurance Company Ltd.\nNiederlassung für Deutschland, Arnulfstraße 31, 80636 München\nGeltungsraum der Versicherung: Weltweit",
  right_title: "Haftungsausschluss",
  disclaimer_content_title: "Haftung für Inhalte",
  disclaimer_content_text: "Die Inhalte unserer Internetpräsenz wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.",
  disclaimer_links_title: "Haftung für Links",
  disclaimer_links_text: "Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.",
  disclaimer_copyright_title: "Urheberrecht",
  disclaimer_copyright_text: "Die durch uns erstellten bzw. verwendeten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen unserer Zustimmung. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf unserer Seite nicht von uns erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.",
  image_credits_title: "Bildnachweise",
  image_credits_intro: "Die auf dieser Webseite verwendeten Fotolia-/Adobe-Stock-Bilder wurden ordnungsgemäß lizenziert. Die detaillierten Urhebernachweise entnehmen Sie bitte der folgenden Übersicht:",
  image_credits_placeholder: "Platzhalter für Bildnachweise (Fotolia-/Adobe-Stock-Liste)",
};

export const buttonizer = {
  trigger_label: "Kontakt",
  phone_label: "Anruf",
  email_label: "E-Mail",
  email_address: "kontakt@net-basis.com",
  whatsapp_label: "WhatsApp",
  whatsapp_link: "https://wa.me/4915126386361",
  telegram_label: "Telegram",
  telegram_link: "https://t.me/ChriGue1",
  signal_label: "Signal",
  signal_link: "https://signal.me/#p/+4915126386361",
  messenger_label: "Messenger",
  messenger_link: "https://m.me/ChriGue1",
  phone_number: "+4921154419380",
  phone_display: "+49 (0) 211 / 544 193 80",
};

export const notFound = {
  title: "Diese Seite wurde noch nicht erstellt",
  message: "Teilen Sie uns mehr über diese Seite mit, damit wir sie für Sie generieren können.",
};